var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFoldingMirrors24 = function SvgFoldingMirrors24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.445h2.804V8.843c0-.422.09-.838.265-1.22a2.83 2.83 0 0 1 .746-.983 2.71 2.71 0 0 1 1.08-.558 2.66 2.66 0 0 1 1.207-.024l10.178 2.15a2.73 2.73 0 0 1 1.551.957c.398.49.625 1.106.642 1.747L21 16.073c.01.38-.052.76-.185 1.114a2.858 2.858 0 0 1-.59.95 2.75 2.75 0 0 1-.901.639 2.666 2.666 0 0 1-1.07.224H7.976a2.7 2.7 0 0 1-1.942-.833 2.895 2.895 0 0 1-.804-2.01H2.426",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7.002 9.036.424 6.92a1.04 1.04 0 0 0 .242.718.911.911 0 0 0 .646.326h9.797a.91.91 0 0 0 .646-.326 1.04 1.04 0 0 0 .242-.717l-.223-2.496-.202-2.268a1.072 1.072 0 0 0-.193-.65.956.956 0 0 0-.533-.375l-2.363-.522-7.432-1.635a.861.861 0 0 0-.403.032.904.904 0 0 0-.351.213c-.1.098-.18.22-.231.354a1.04 1.04 0 0 0-.066.426v0Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 7v1.921c0 .536-.075 1.066-.22 1.561-.147.495-.36.945-.63 1.323-.27.38-.59.68-.941.885-.352.205-.73.31-1.11.31H15",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m13.081 12.91 2.535-1.863a.266.266 0 0 1 .248-.028.22.22 0 0 1 .098.074c.024.032.037.07.038.108v3.596a.182.182 0 0 1-.035.108.223.223 0 0 1-.095.075.262.262 0 0 1-.245-.024l-2.538-1.733a.211.211 0 0 1-.063-.07.182.182 0 0 1-.003-.172.21.21 0 0 1 .06-.07Z",
    fill: "currentColor"
  })));
};
export default SvgFoldingMirrors24;